import { useQuery } from '@tanstack/vue-query'
import { FIVE_MINUTES_MS } from '@shared/utils'
import { getUserProfile } from '../profileEndpoints'
import { profileKeys } from '../profileQueryKeys'

export function useUserProfileQuery() {
  return useQuery({
    queryKey: profileKeys.user(),
    queryFn: getUserProfile,
    staleTime: FIVE_MINUTES_MS,
  })
}
